import React from 'react';
import styled from 'fe-styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import ExternalLink from '../ExternalLink';

const PROP_TYPES = {
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string,
  name: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired,
  description: PropTypes.string,
  isCentered: PropTypes.bool,
};

// Refer to index.js for an explanation of these values
const InfoBlobView = styled.div`
  max-width: 730px;
  ${(p) => (p.isCentered ? 'text-align: center; margin: auto;' : null)}
  padding: ${theme.spacingMd} 0;
  font-family: ${theme.fontFamilyPrimary};

  @media only screen and (min-width: ${theme.breakpointMd}) {
    ${(p) => (p.isCentered ? null : 'width: 50%')};
    padding: 0 ${theme.spacingXl};
  }
`;

const Title = styled.div`
  font-size: ${theme.fontSizeH3};
  margin-bottom: ${theme.spacingMd};
  font-weight: ${theme.fontWeightSemibold};
  color: #444;

  @media only screen and (min-width: ${theme.breakpointMd}) {
    font-size: ${theme.fontSizeH2};
  }
`;

const Graphic = styled.img`
  max-height: 64px;
  max-width: 100%;
`;

const GraphicWrapper = styled.div`
  margin: ${theme.spacingMd} 0;
  display: block;
  height: 64px;
  max-width: 100%;
  display: flex;
  align-items: center;
  ${(p) => (p.isCentered ? 'justify-content: center;' : null)}
`;

const Name = styled.div`
  font-size: ${theme.fontSizeXl};
  font-weight: ${theme.fontWeightSemibold};
  margin-bottom: ${theme.marginBase};

  @media only screen and (min-width: ${theme.breakpointMd}) {
    font-size: ${theme.fontSizeXxl};
  }
`;

const LinksContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: ${(p) => (p.isCentered ? 'center' : 'flex-start')};
`;

const Description = styled.div`
  font-size: ${theme.fontSizeBase};
  margin-top: ${theme.marginBase};
  line-height: 1.5;
`;

const InfoBlob = ({
  title,
  name,
  links,
  thumbnail,
  description,
  isCentered,
}) => {
  return (
    <InfoBlobView isCentered={isCentered}>
      <Title>{title}</Title>
      {thumbnail && (
        <GraphicWrapper isCentered={isCentered}>
          <Graphic src={thumbnail} alt={name} />
        </GraphicWrapper>
      )}
      <Name>{name}</Name>
      <LinksContainer isCentered={isCentered}>
        {links.map((link, index) => (
          <ExternalLink
            key={index}
            label={link.label}
            href={link.href}
            gaTrackId={link.gaTrackId}
            gaTrackInfo={link.gaTrackInfo}
          />
        ))}
      </LinksContainer>
      {description ? (
      <Description>{description}</Description>) : null }
    </InfoBlobView>
  );
};

InfoBlob.propTypes = PROP_TYPES;

export default InfoBlob;
